import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, TableList } from 'seagull';
export const ProposalsReportRow = (props)=>{
    const { data } = props;
    const items = [
        {
            value: /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: "proposals-report-row-".concat(props.index, "-company-name"),
                        variant: "paragraph1",
                        noWrap: true,
                        ellipsis: true,
                        children: data.companyName()
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        skin: "secondary",
                        noWrap: true,
                        variant: "paragraph2",
                        ellipsis: true,
                        testId: "proposals-report-row-agreement-name",
                        children: data.agreementName()
                    })
                ]
            })
        },
        {
            value: /*#__PURE__*/ _jsx(Typography, {
                testId: "proposals-report-row-".concat(props.index, "-sent-by"),
                variant: "paragraph1",
                noWrap: true,
                ellipsis: true,
                children: data.sentByName()
            })
        },
        {
            value: /*#__PURE__*/ _jsx(Typography, {
                testId: "proposals-report-row-".concat(props.index, "-sent-date"),
                variant: "paragraph1",
                noWrap: true,
                children: data.formattedSentDate()
            })
        },
        {
            value: /*#__PURE__*/ _jsx(Typography, {
                testId: "proposals-report-row-".concat(props.index, "-approval-date"),
                variant: "paragraph1",
                noWrap: true,
                children: data.formattedApprovalDate()
            })
        },
        {
            value: /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(Typography, {
                    testId: "proposals-report-row-".concat(props.index, "-status"),
                    variant: "paragraph1",
                    noWrap: true,
                    ellipsis: true,
                    children: data.statusLabel()
                })
            })
        }
    ];
    return /*#__PURE__*/ _jsx(TableList.Row, {
        items: items,
        rowId: props.index,
        testId: "proposals-report-row-".concat(props.index),
        "data-heapid": "proposals-report-row"
    });
};
